"use client"
import { Component, createRef } from 'react';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import Styles from "./NSListGrouped.module.css";
import { NSLoading } from './NSLoading';

export interface NSListGroupedProps<Data> extends IBaseComponentProps
{
	groups: NSListGroupedProps_Group<Data>[];
	onClick: (group: NSListGroupedProps_Group<Data>, item: NSListGroupedProps_Item<Data>) => void;
	onClose: () => void;
}

export interface NSListGroupedProps_Group<Data>
{
	value: string;
	text: string;
	items: NSListGroupedProps_Item<Data>[] | null;
}

export interface NSListGroupedProps_Item<Data>
{
	value: Data
	text: string;
	text_bold?: string;
	description?: string;
}

interface NSListGroupedState
{
}

export class NSListGrouped<Data> extends Component<NSListGroupedProps<Data>, NSListGroupedState>
{
	private groupListRef = createRef<HTMLDivElement>();

	constructor(props: NSListGroupedProps<Data>) 
	{
		super(props);
		this.state = {};
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	override componentDidMount() 
	{
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	override componentWillUnmount()
	{
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside(event: MouseEvent)
	{
		if (this.groupListRef.current && !this.groupListRef.current.contains(event.target as Node))
			this.props.onClose();
	}
	override render()
	{
		return (
			<div
				ref={this.groupListRef}
				id={this.props.id}
				className={`${Styles.ns_list_grouped_parent} ${this.props.classList?.join(" ") ?? ""}`}
				style={this.props.style}
			>
				{
					this.props.groups.map((group, index) => (
						(group.items == null || group.items.length > 0) &&
						<ul key={`NSListGrouped_ul_key_${index}`} className={Styles.ns_list_grouped}>
							<div className='d-flex w-100 justify-content-between align-items-center'>
								<span className={Styles.ns_group_category}>{group.text}
									<img
										onClick={this.props.onClose}
										src="https://static.namirasoft.com/image/concept/close/blue.svg"
										alt="input-icon"
										width={24}
										height={24}
										style={{ cursor: "pointer" }}
									/>
								</span>
							</div>
							{
								group.items == null &&
								<NSLoading />
							}
							{
								group.items?.map((item) => (
									<li key={`NSListGrouped_li_key_${index}`} onClick={() => this.props.onClick(group, item)}>
										<div className={Styles.ns_group_item}>
											<span>{item.text && <span>{item.text}</span>}</span>
											<span style={item.text_bold ? { fontWeight: 'bold' } : {}}>
												<b> {item.text_bold}</b>
											</span>
											{item.description && <span className={Styles.ns_block}>{item.description}</span>}
										</div>
									</li>
								))
							}
						</ul>
					))
				}
			</div>
		);
	}
}